import {REPORT_NEW_ORGANIZATION_ORDERS} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_ORGANIZATION_ORDERS,
};
